var map = {
	"./add_annoucment.svg": 64501,
	"./add_annoucment_hover.svg": 96237,
	"./add_meeting.svg": 85443,
	"./add_meeting_hover.svg": 22304,
	"./archive-solid.svg": 20444,
	"./arrow.svg": 84339,
	"./box-archive.svg": 48124,
	"./calendar-days.svg": 58007,
	"./callendar-gray.svg": 26942,
	"./callendar.svg": 76288,
	"./comment-sms.svg": 12738,
	"./eye-slash.svg": 90782,
	"./eye.svg": 12900,
	"./globe.svg": 55307,
	"./news.svg": 36503,
	"./send_e-mail.svg": 59300,
	"./send_e-mail_hover.svg": 41642,
	"./send_sms.svg": 97939,
	"./send_sms_hover.svg": 43457,
	"./time.svg": 46960,
	"./warning.svg": 68792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41130;